export const CHANGE_FEE_CODE = "fee/CHANGE_FEE_CODE";
export const SEARCH_FEE_CODE = "fee/SEARCH_FEE_CODE";
export const SEARCH_FEE_CODE_SUCCESS = "fee/SEARCH_FEE_CODE_SUCCESS";
export const SEARCH_FEE_CODE_ERROR = "fee/SEARCH_FEE_CODE_ERROR";
export const SELECT_FEE = "fee/SELECT_FEE";
export const CLEAR_DATA_SEARCH_FEE_CODE = "fee/CLEAR_DATA_SEARCH_FEE_CODE";
export const ON_CHANGE_EMAIL = "fee/ON_CHANGE_EMAIL";

export const REQUEST_PAYMENT_FEE = "REQUEST_PAYMENT_FEE";
export const REQUEST_PAYMENT_FEE_SUCCESS = "REQUEST_PAYMENT_FEE_SUCCESS";
export const REQUEST_PAYMENT_FEE_FAILURE = "REQUEST_PAYMENT_FEE_FAILURE";

// ------------------

export const CHANGE_RECEIPT_NUMBER = "fee/CHANGE_RECEIPT_NUMBER";
export const SELECT_METHOD_AND_BANK = "fee/SELECT_METHOD_AND_BANK";
export const CHANGE_PATIENT_NUMBER = "fee/CHANGE_PATIENT_NUMBER";
export const CLEAR_STATE = "fee/CLEAR_STATE";
export const CHANGE_SEARCH_TAB = "fee/CHANGE_SEARCH_TAB";
export const CHANGE_PAY_ID_LIST = "fee/CHANGE_PAY_ID_LIST";

export const GET_ALL_FEE_REQUEST = "fee/GET_ALL_FEE_REQUEST";
export const GET_ALL_FEE_SUCCESS = "fee/GET_ALL_FEE_SUCCESS";
export const GET_ALL_FEE_FAILURE = "fee/GET_ALL_FEE_FAILURE";

export const GET_BANK_REQUEST = "fee/GET_BANK_REQUEST";
export const GET_BANK_SUCCESS = "fee/GET_BANK_SUCCESS";
export const GET_BANK_FAILURE = "fee/GET_BANK_FAILURE";

export const GET_ORDER_REQUEST = "fee/GET_ORDER_REQUEST";
export const GET_ORDER_SUCCESS = "fee/GET_ORDER_SUCCESS";
export const GET_ORDER_FAILURE = "fee/GET_ORDER_FAILURE";

export const GET_ORDER_OFFLINE_REQUEST = "fee/GET_ORDER_OFFLINE_REQUEST";
export const GET_ORDER_OFFLINE_SUCCESS = "fee/GET_ORDER_OFFLINE_SUCCESS";
export const GET_ORDER_OFFLINE_FAILURE = "fee/GET_ORDER_OFFLINE_FAILURE";

export const SHOW_LOADING = "fee/SHOW_LOADING";
export const HIDE_LOADING = "fee/HIDE_LOADING";

export const GET_FEES_HISTORY = "fee/GET_FEES_HISTORY";
export const GET_FEES_HISTORY_SUCCESS = "fee/GET_FEES_HISTORY_SUCCESS";
export const GET_FEES_HISTORY_FAILURE = "fee/GET_FEES_HISTORY_FAILURE";

export const GET_ALL_PAYMENT_METHOD = "fee/GET_ALL_PAYMENT_METHOD";

export const GET_HISTORY_PAYMENT = "fee/GET_HISTORY_PAYMENT";
export const GET_HISTORY_PAYMENT_SUCCESS = "fee/GET_HISTORY_PAYMENT_SUCCESS";
export const GET_HISTORY_PAYMENT_FAILURE = "fee/GET_HISTORY_PAYMENT_FAILURE";
